import { render } from "./TopBar.vue?vue&type=template&id=6e90070e&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=6e90070e&scoped=true&lang=css"

import exportComponent from "/Users/jluan/code/whatgpt/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e90070e"]])

export default __exports__